import React from 'react';

import { Heading } from '@depop/web-thrift-ui/Typography';

import styles from './styles.module.css';

import { FeaturedImage } from '@/components/MegaNav/FeatureImage';
import { isNotNull } from '@/modules/cms/helpers/isNotNull';
import { type ImageLinkList } from '@/modules/meganav/types';

type Props = {
  config: ImageLinkList;
};

export function PopularTiles({ config }: Props) {
  return (
    <div className={styles.container}>
      {config.title && (
        <Heading variant="sm" className={styles.heading}>
          {config.title}
        </Heading>
      )}
      <div className={styles.featuredContainer}>
        {config.itemsCollection.items.filter(isNotNull).map((item) => (
          <FeaturedImage key={item.slug} {...item} />
        ))}
      </div>
    </div>
  );
}
